.NewsletterContainer {
  position: relative;
  width: 100%;
  padding-right: var(--space-sm);
  padding-left: var(--space-sm);

  p {
    margin-top: 0;
    margin-bottom: var(--newsletter-space-1);
  }
  .imgFluid {
    max-width: 100%;
    height: auto;
  }
  h3.author {
    font-size: var(--newsletter-author-font-size);
    line-height: var(--newsletter-author-lh);
    font-weight: var(--font-weight-medium);
    color: var(--color-bh-black);
    margin-top: var(--newsletter-author-space);
    margin-bottom: var(--newsletter-author-space);
  }
}
